export const environments = {
  LOCAL: 'local',
  STAGING: 'staging',
  PREPROD: 'preprod',
  SANDBOX: 'sandbox',
  PRODUCTION: 'production',
  TEST: 'Test'
}
